import { colors } from "../common/styles";

export default {
    tabHeader: { px: 2, py: 4 },

    tabContentContainer: { borderBottom: 1, borderColor: "divider" },
    tabPanelList: {
        "&  .MuiDataGrid-root": { height: "75vh" }
    },
    mainHeaderContainer: {
        mx: 2,
        my: 4,
        "& h6": {
            verticalAlign: "middle"
        },
        "& > *": { display: "inline-block" }
    },
    primaryButton: {
        backgroundColor: colors.blue,
        color: colors.white,
        borderRadius: 32,
        px: 2,
        py: 1
    }
};
